import * as types from "./loginactionstypes";
import loginService from "../services/loginservice";
import * as appActions from "../../../actions/appactions";
import securityService from "../../../services/securityservice";
import * as securityActions from "../../../actions/securityactions";
import sharedGlobals from "../../../sharedglobals";
export const updateLoginState = ({ name, value }) => {
  return {
    type: types.UPDATE_LOGIN_STATE,
    payload: { name, value },
  }
}
export const resetLoginState = () => {
  return {
    type: types.RESET_LOGIN_STATE,

  }
}

export const setLoginMessage = (loginMessage) => {
  return {
    type: types.SET_LOGIN_MESSAGE,
    payload: loginMessage,
  };
};

export const clientLogin = (redirPageMenuId) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      
      let sr = await loginService.clientLogin(
        currentState.userName,
        currentState.password
      );
      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        dispatch(setLoginMessage(message));
        return Promise.resolve(false);
      }
      securityService.setSession(sr.result);
      if (redirPageMenuId) {
        let hasPermission = false;
        try {
          if (
            await dispatch(
              securityActions.checkAccess({ pageMenuId: redirPageMenuId })
            )
          ) {
            hasPermission = true;
          }
        } catch (e) {}
        /*if(!hasPermission){
            dispatch(setLoginMessage('Permission denied'));
          }else{*/
        if (hasPermission) {
          dispatch(securityActions.redirectToPage(redirPageMenuId));
          return Promise.resolve(false);
        }
      }
      return Promise.resolve(true);
    } catch (e) {
      dispatch(setLoginMessage(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
};

export const sendForgotPassword = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      console.log(currentState.resetEmail);
      let paramss={
        "userEmail": currentState.resetEmail,
        "loginUserName": currentState.userNametoReset,

      }
      let sr = await loginService.sendForgotPassword(paramss);
      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        console.log(message);
        {
        let name= "forgotPasswordMessage";
        let value = message;
        await dispatch(updateLoginState({name, value}));
      }
        return Promise.resolve(false);
      }
      {
        let name= "forgotPasswordMessage";
        let value = '';
        await dispatch(updateLoginState({name, value}));
      }
      //console.log(sr);
      return Promise.resolve(true);
    } catch (e) {
    }
    finally{
      dispatch(appActions.setLoading(false));
    }
  };
};
export const resetPasswordByForgotPasswordKey = (passwordResetKey) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await loginService.resetPasswordByForgotPasswordKey(passwordResetKey, currentState.newUserPassword);
      if (sr.hasErrors) {
        let message = sr.errors[0].errorMessage;
        return message;
      }
      return null;
    } catch (e) {
    }finally{
      dispatch(appActions.setLoading(false));
    }
  };
};
export const redirectToMicrosoft=(redirPageMenuId)=>{
  localStorage.setItem('redirPageMenuId',redirPageMenuId);
  let redirUrl=sharedGlobals.appUrls.securityApiUrl + "api/Security/ProcessRedirectFromMicrosoft";
  redirUrl=encodeURIComponent(redirUrl);
  //  alert(redirUrl);
  let tenant='organizations';
  let url ='https://login.microsoftonline.com/'+tenant+'/oauth2/v2.0/authorize?'+
  'client_id=5c04f094-4881-4fd9-b361-5aecc87dd2d0'+
  '&response_type=code'+
  '&redirect_uri='+ redirUrl+
  '&response_mode=query'+
  '&scope=user.read%20openid%20profile%20email'+
  '&state=12345'
  //  alert(url);
  window.location.href=url; 
};
const getState = (state) => {
  return state.loginReducer;
};
